<template>
  <p
    class="event-dates"
    v-if="show_start_date || show_end_date"
  >
    <slot name="icon">
      <fa-icon
        class="color--prim icon event-dates__icon"
        :icon="['fal', 'calendar-clock']"
      />
    </slot>

    <span class="event-dates__dates">
      <app-date
        class="event-dates__date"
        :timestamp="start_date"
        :filter="date_format"
        v-if="show_start_date"
      />

      <template v-if="show_start_date && show_end_date">
        -
      </template>

      <template v-else-if="!show_start_date">
        {{ t('literal.ends_on') }}
      </template>

      <app-date
        class="event-dates__date"
        :timestamp="end_date"
        :filter="end_date_format"
        v-if="show_end_date"
      />
    </span>
  </p>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { isSameDay } from 'date-fns'

const AppDate = defineAsyncComponent(() => import('&/atoms/AppDate'))

const { project, showStartDate, showEndDate, dateFormat } = defineProps({
  project: { type: Object, required: true },
  showStartDate: { type: Boolean, default: true },
  showEndDate: { type: Boolean, default: true },
  dateFormat: { type: String, default: 'EEEE, dd MMMM yyyy' }
})

const { t } = useI18n()

const start_date = project?.event_start_date ? new Date(project.event_start_date) : null
const end_date = project?.event_end_date ? new Date(project.event_end_date) : null

const date_format = project?.show_event_time ? `${dateFormat} HH:mm` : dateFormat
const is_same_date = start_date && end_date && isSameDay(start_date, end_date)
const show_start_date = showStartDate && !!start_date
const show_end_date = showEndDate && !!end_date && !(is_same_date && !project?.show_event_time)
const end_date_format = is_same_date && show_start_date ? 'HH:mm': date_format
</script>

<style lang="scss" scoped>
.event-dates {
  &__dates {
    display: flex;
    flex-wrap: wrap;
    column-gap: 4px;
  }

  &__date {
    white-space: nowrap;
  }
}
</style>